// 📂 unfamiliar-games-frontend/src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Home from "./pages/Home";
import Leaderboard from "./pages/Leaderboard";
import Game from "./pages/Game";
import GlobalLeaderboard from "./pages/GlobalLeaderboard";
import "./App.css";

const Header = () => (
  <header className="header">
    <h1>🎮 Unfamiliar Gaming</h1>
    <nav>
      <Link to="/">🏠 Home</Link>
      <Link to="/global-leaderboard">🏆 Global Leaderboard</Link>
    </nav>
  </header>
);

const Footer = () => (
  <footer className="footer">
    <p>© 2025 Unfamiliar Games. All rights reserved.</p>
  </footer>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/games/:id" element={<Game />} /> {/* ✅ FIXED */}
          <Route path="/leaderboard/:gameId" element={<Leaderboard />} />
          <Route path="/global-leaderboard" element={<GlobalLeaderboard />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;